import React from "react";
import { useSelector } from "react-redux";
import "./blockScreen.scss";
import Lottie from "react-lottie";
import LogoPrideJson from "../../assets/imgs/landing/logo-pridemx.json";

export const BlockScreen = () => {

  const blocking = useSelector((state) => state.blocking);

    if (!blocking) return null;

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: LogoPrideJson,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

  return (
      <div className="custom-modal__overlay">
          <div className="custom-modal__content">
              <div className="lottie-wrapper">
                  <Lottie options={defaultOptions} />
              </div>
          </div>
      </div>
  );
};
